<div *ngFor="let section of sections" class="preview-section">
  <h2 class="preview-section-title" *ngIf="section.title" [innerHTML]="getFormattedHtml(section.title)"></h2>

  <div *ngFor="let row of section.rows" class="preview-row">
    <div *ngFor="let sub of row.subSections; let i = index"
         class="preview-sub-section"
         [style.grid-column]="'span ' + getPreviewGridColumnSpan(sub.widthSpan)"
         [style.grid-row]="'span ' + sub.heightSpan">

      <ng-container *ngIf="sub.type === 'text'">
        <div class="preview-text-block">
          <h3 class="preview-text-title" *ngIf="sub.title" [innerHTML]="getFormattedHtml(sub.title)"></h3>
          <p class="preview-text-content" *ngIf="sub.content" [innerHTML]="getFormattedHtml(sub.content)"></p>

          <div class="preview-buttons" *ngIf="sub.buttons && sub.buttons.length > 0">
            <button *ngFor="let button of sub.buttons"
                    mat-button
                    class="preview-button"
                    [ngStyle]="{
                      'background-color': button.type === 'primary' ? getPrimaryButtonColor() :
                                          button.type === 'secondary' ? '#fff' : '#fff',
                      'color': button.type === 'primary' ? '#fff' : getPrimaryButtonColor(),
                      'border': button.type === 'secondary' ? '1px solid ' + getPrimaryButtonColor() : 'none'
                    }"
                    [innerHTML]="getFormattedHtml(button.label)"
                    (click)="onButtonClick(button, sub)"
                    >
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="sub.type === 'image'">
        <div class="preview-image-block">
          <img *ngIf="sub.imageUrl" [src]="sub.imageUrl" [alt]="sub.title || 'Image'" />
          <div *ngIf="!sub.imageUrl" class="preview-image-placeholder">
            [Image]
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>
